import AIEduButton from '../../../components/Button/AIEduButton';
import AIEduDialog from '../../../components/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const DeleteEmergencyAlertDialog = ({
    hideDeleteAlertDialog,
    deleteSelectedAlerts,
    visible,
    deleteMessage,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    
    const deleteAlertDialogFooter = (
        <div className='flex justify-content-end'>
            <AIEduButton
                label={f({ id: 'AI_EDU_CANCEL' })}
                className='btnSecondary'
                onClick={hideDeleteAlertDialog}
            />
            <AIEduButton
                label={f({ id: 'AI_EDU_DELETE' })}
                className='btnDelete'
                onClick={deleteSelectedAlerts}
            />
        </div>
    );

    const deleteAlertTitle = () => {
        return (
            <div
                className='flex justify-content-between pb-2'
                style={{ borderBottom: '1px solid var(--primary-background)' }}
            >
                <div>{f({ id: 'AI_EDU_DELETE_ALERT' })}</div>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={hideDeleteAlertDialog}
                >
                    <i className='pi pi-times' />
                </div>
            </div>
        );
    };

    return (
        <AIEduDialog
            visible={visible}
            style={{ width: '40rem', fontFamily: 'SamsungOne-600, sans-serif' }}
            title={deleteAlertTitle}
            footer={deleteAlertDialogFooter}
            onHide={hideDeleteAlertDialog}
            content={
                <>
                    <i
                        className='pi pi-exclamation-triangle mr-3'
                        style={{ fontSize: '2rem' }}
                    />
                    <span>{deleteMessage}</span>
                </>
            }
        />
    );
};

export default DeleteEmergencyAlertDialog;
